import { apiService } from './apiService';
import { Reminder, CreateSystemReminderData, UpdateReminderData } from '../models/reminder';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export const remindersService = {
  getReminders: async (patientId: string): Promise<Reminder[]> => {
    try {
      const data = await apiService.get(`${API_BASE_URL}/clinic/patient/${patientId}/reminders/`);
      return data.results ?? data;
    } catch (err) {
      console.error('Error fetching reminders:', err);
      throw err;
    }
  },

  createReminder: async (patientId: string, reminderData: CreateSystemReminderData): Promise<Reminder> => {
    try {
      return await apiService.post(`${API_BASE_URL}/clinic/patient/${patientId}/reminders/`, reminderData);
    } catch (err) {
      console.error('Error creating reminder:', err);
      throw err;
    }
  },

  updateReminder: async (patientId: string, reminderId: number, data: UpdateReminderData): Promise<Reminder> => {
    try {
      return await apiService.patch(`${API_BASE_URL}/clinic/patient/${patientId}/reminders/${reminderId}/`, data);
    } catch (err) {
      console.error('Error updating reminder:', err);
      throw err;
    }
  },

  deleteReminder: async (patientId: string, reminderId: number): Promise<void> => {
    try {
      await apiService.delete(`${API_BASE_URL}/clinic/patient/${patientId}/reminders/${reminderId}/`);
    } catch (err) {
      console.error('Error deleting reminder:', err);
      throw err;
    }
  },
};
